
export default {
  getterListItemInCart: state => {
    return state.listItemInCart;
  },
  getterAddressUser: state => {
    return localStorage.getItem('addressUser') != null ? localStorage.getItem('addressUser') : state.addressUser;
  },
}



// WEBPACK FOOTER //
// ./src/store/cart/getters.js